export function toc(linkSelector = '.toc__link', offset = -100) {
  const links = document.querySelectorAll(linkSelector);

  const setActive = (activeLink) => {
    links.forEach((link) => {
      link.classList.remove('is-active');
    });
    activeLink.classList.add('is-active');
  };

  links.forEach((link) => {
    const id = link.href.split('#')[1];
    if (!id) return;

    const element = document.getElementById(id);
    if (!element) return;

    const options = {
      root: null,
      rootMargin: `${offset}px`,
      rootThreshold: 0,
    };
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          console.log(id, link);
          setActive(link);
        }
      });
    }, options);

    observer.observe(element);
  });
}
